/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState,useEffect, useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { List, ListItem } from "@material-ui/core";
import { useLocation } from 'react-router-dom';
import AuthContext from "../../hooks/authContext";
import ChildMenuItem from "./ChildMenuItem";

const MenuItem = (props) => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const { item, handleDrawerToggle, change } = props;
  const rawRole = auth?.userProfile?.role;
  const employeeRole = auth?.userProfile?.employeerole;

  const role = [
    ...(Array.isArray(rawRole) ? rawRole : rawRole ? [rawRole] : []),
    ...(Array.isArray(rawRole)
        ? rawRole.includes("Employee") && employeeRole ? [employeeRole] : []
        : rawRole === "Employee" && employeeRole ? [employeeRole] : []
    )
  ].filter(Boolean);
  const [clickedLink, setClickedLink] = useState('');
  // const hasAccess = item?.roles.includes(role) ? true : false;
  const hasAccess = role.some(r => item.roles.includes(r));
  const isChildRouteActive = item?.childItems?.some((child) => location.pathname === child.to);
  
  const hasChild = (typeof item?.childItems !== 'undefined' && item?.childItems?.length > 0) ? true : false;
  let isChildActive = false;

  let isShowBadge = false;
  if(item.to === '/communications') {
      if(!auth.isReadPrivate || !auth.isReadPublic) {
        isShowBadge = true;
      }
  }
  if(item.to === '/help') {
      if(auth?.pendingSupportStatus > 0) {
        isShowBadge = true;
      }
  }
  if(item.to === '/operations') {
      if(auth?.pendingSupplyStatus?.length > 0) {
        isShowBadge = true;
      }
  }
  if(item.to === '/operations') {
      if(auth?.highPrioritySupply?.length > 0) {
        isShowBadge = true;
      }
  }
  if(item.to === '/operations') {
      if(auth?.issueCount > 0) {
        isShowBadge = true;
      }
  }

  const [showChild, setShowChild] = useState(false);
  const renderMenuChilditem = (item) => {
    return showChild === true && <List key={"subitem"+item} className="submenuitems ml-40">
      {item?.childItems?.map((child,index) => {
        const labels = child?.childItems?.length > 0 ? location?.pathname === "/supplies/cleaning/review" ? child?.childItems?.[0]?.label : child?.childItems?.[1]?.label : null;
        const tourAttr = getSubMenuTourAttribute(item?.label, child?.label, labels);
        // const labels = startTours === "supplies" ? location?.pathname === "/supplies/cleaning/review" ? "supplies-new" : "supplies-manage" : tourAttr;
        return <ChildMenuItem key={"childmenuitemwrap"+index} tourAttr={tourAttr} item={child} index={index} handleDrawerToggle={handleDrawerToggle} change={change}/>
      })}
    </List>
  }
  const showChildMenu = (e) => {
    e.preventDefault();
    const dataID = e.currentTarget.getAttribute('dataid');
    if(dataID) {
      // e.preventDefault();
      if(showChild) {
        setClickedLink('');
      } else {
        setClickedLink(dataID);
      }
      
      setShowChild(!showChild);
    } else {
      setClickedLink('');
    }
  }

  const doesMenuHaveActiveChild = (items = [], parentTo = '') => {
    for (let child of items) {
      if (!child) continue;

      const fullPath = child?.to || '';
      if (location?.pathname === fullPath || location?.pathname?.startsWith(fullPath) || location?.pathname?.startsWith(parentTo)) {
        return true;
      }

      if (child?.childItems && child?.childItems?.length > 0) {
        if (doesMenuHaveActiveChild(child?.childItems, fullPath)) return true;
      }
    }
    return false;
  };

  const checkactive = () => {
    if (hasChild) {
      const isChildActive = doesMenuHaveActiveChild(item?.childItems, item?.to);
      setClickedLink(isChildActive ? item?.to : '');
      setShowChild(isChildActive);
    }
  };
  useEffect(() => { 
    checkactive();
  },[location.pathname])


    const getTourAttribute = (label) => {
      switch (label?.toLowerCase()) {
        case 'people':
          return 'people-nav';
        case 'operations':
         return 'operations-nav';
        case 'supplies':
         return 'operations-nav';
        case 'communications':
         return 'communications-nav';
        case 'help':
         return 'help-nav';
        case 'reports':
         return 'report-nav';
        default:
          return undefined;
      }
    };

  const getSubMenuTourAttribute = (parent, child, grandchild = null) => {
    const tourMap = {
      operations: {
        appointments: 'appointment-manage',
        issues: 'issues-manage',
        supplies: {
          'new request' : 'supplies-new',
          manage: 'supplies-manage'
        }
      },
      people: {
        employees: 'team-manage',
        clients: 'client-manage'
      },
      communications: {
        'message board': 'live-chat',
        channels: 'manage-channels',
      },
      help: {
        support: 'support-manage',
        tour: 'tour-nav'
      },
      reports: {
        'client reports' : 'client-report',
        'team reports' : 'team-report',
      }
    };

    const parentMap = tourMap[parent?.toLowerCase()];
    if (!parentMap) return null;

    const childMap = parentMap[child?.toLowerCase()];
    if (!childMap) return null;


      if (typeof childMap === 'string') {
      return childMap;
    }

    if (grandchild && typeof childMap === 'object') {
      return childMap[grandchild?.toLowerCase()] || null;
    }

    return null;
  };

  const tourAttr = getTourAttribute(item?.label);
  const startTours = localStorage.getItem('startTour');

  useEffect(() => {
    const tourMap = {
      'getting-started': "help-nav",
      clients: "people-nav",
      employee: "people-nav",
      appointments: "operations-nav",
      supplies: "operations-nav",
      issues: "operations-nav",
      messages: "communications-nav",
      help: 'help-nav',
      reports: 'report-nav'
    };

    const currentNav = tourMap[startTours];

    if (currentNav && currentNav === tourAttr) {
      setClickedLink(item.to);
      setShowChild(true);
    }
  }, [startTours, tourAttr, item.to]);

  return ( hasAccess && <>
    <ListItem key={item.label + props.index}  {...(tourAttr && { 'data-tour': tourAttr })}>
      {hasChild === true ? 
        <Link dataid={item.to} onClick={showChildMenu}   className={`nav-link ${isChildRouteActive ? "parent-active" : ""} ${item?.classes || ""}`}> 
        {item?.icon && item.icon}{isShowBadge && <span className="absolute top-0 right-0 h-2 w-2 bg-[#fc8600] rounded-full MenuBadgeIcon" />}
        <span className={change ? "ml-20" : ""}>{item.label}</span>
        <KeyboardArrowDownIcon fontSize="small" dataid={item.to} className={`menuRightArrowIcon ${clickedLink === item.to?'menuRightARrowDownIcon':''}`}/>
        </Link>
        : <NavLink className={({ isActive }) => `nav-link ${isActive ? "active" : ""} ${item?.classes || ""}`} to={item.to}> 
        {item?.icon && item.icon} <span className={change ? "ml-20" : ""}>{item.label}</span></NavLink >
      }
      {typeof item?.childItems !== 'undefined' && item?.childItems?.length > 0 && renderMenuChilditem(item)}
    </ListItem>
  </>
  );
};

export default MenuItem;
